<template>
  <menu-list :type="type" :list="officeMenuList"> </menu-list>
</template>

<script>
import { mapGetters } from "vuex";
import MenuList from "./MenuList";

export default {
  name: "ContentOffice",
  components: { MenuList },
  data() {
    return {
      type: "OFFICE",
    };
  },
  computed: {
    ...mapGetters(["officeMenuList"]),
  },
};
</script>

<style scoped>

</style>
